var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4621_10151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2748 0.769531H6.09014C5.42856 0.769531 4.79593 1.00371 4.25721 1.51472L1.6235 4.11801C1.15536 4.58615 0.84375 5.23421 0.84375 5.97724V14.3314C0.84375 15.7861 2.02764 16.9696 3.48272 16.9696H11.597C12.3257 18.057 13.3531 18.8201 14.6952 19.2018C14.8279 19.2397 14.9735 19.2418 15.1151 19.2022C18.7013 18.1865 19.4916 14.6795 19.0379 11.7611C18.9943 11.4017 18.7825 11.0888 18.4407 10.8927L15.3074 9.19952C15.1868 9.13496 15.055 9.10158 14.9213 9.08276V3.40813C14.9213 1.95305 13.7344 0.769531 12.2748 0.769531ZM3.48272 15.4311C2.87575 15.4311 2.38221 14.938 2.38221 14.3314V5.97724C2.38221 5.67281 2.51042 5.40614 2.70823 5.20914L5.32767 2.62012C5.54503 2.41273 5.78607 2.30799 6.09014 2.30799H12.2748C12.8855 2.30799 13.3828 2.80153 13.3828 3.40813V9.64273L11.0804 10.8916C10.7475 11.0698 10.5 11.4107 10.4794 11.787C10.4794 11.8707 10.2537 13.6466 10.8325 15.4311H3.48272ZM17.5407 12.1551C17.7045 13.4138 17.8262 16.68 14.9055 17.6569C13.1181 17.0611 12.267 15.6083 12.0318 13.7315C11.9505 13.0668 11.9679 12.4859 11.9916 12.1476L14.7553 10.6497L17.5407 12.1551Z",
    fill: "#99A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9288 7.92157C10.9288 7.49677 10.5847 7.15234 10.1596 7.15234H5.60126C5.17608 7.15234 4.83203 7.49677 4.83203 7.92157C4.83203 8.34638 5.17608 8.69081 5.60126 8.69081H10.1596C10.5847 8.69081 10.9288 8.34638 10.9288 7.92157Z",
    fill: "#99A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88041 10.6816H5.60126C5.17608 10.6816 4.83203 11.0261 4.83203 11.4509C4.83203 11.8757 5.17608 12.2201 5.60126 12.2201H7.88041C8.30559 12.2201 8.64964 11.8757 8.64964 11.4509C8.64964 11.0261 8.30559 10.6816 7.88041 10.6816Z",
    fill: "#99A4A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4621_10151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyImage);
export default __webpack_public_path__ + "static/media/privacyImage.b207b954244bad356eb4ea990f94a6c2.svg";
export { ForwardRef as ReactComponent };